import { z } from 'zod';

import type { MatchesSchema } from '@/shared/api/contract';

/**
 * Lista robocza „elementy bez własnego właściciela" (decyzja 106, krok K8).
 *
 * ⭐ Dwa kubełki, bo to dwa różne pytania. „Nikt w całym łańcuchu" jest **realną dziurą
 * w odpowiedzialności** — nie ma kogo zapytać o ten byt. „Dziedziczy po X" to stan zwykle
 * poprawny: ktoś nad nim odpowiada, a decyzja sprowadza się do „tak, to wystarczy".
 */
export const ownerlessBranchSchema = z.object({
  /** `null` znaczy „nikt w całym łańcuchu". */
  sourceElementId: z.number().nullable(),
  sourceOwnerKind: z.number().nullable(),
  sourceTitle: z.string().nullable(),
  count: z.number(),
  reviewedCount: z.number(),
});

export const ownerlessSummarySchema = z.object({
  nobodyCount: z.number(),
  inheritedCount: z.number(),
  reviewedCount: z.number(),
  nobody: z.array(ownerlessBranchSchema),
  inherited: z.array(ownerlessBranchSchema),
});

export const ownerlessElementSchema = z.object({
  id: z.number(),
  title: z.string(),
  type: z.string().nullable(),
  /** ⚠ To NIE jest właściciel — to ślad, że ktoś na to spojrzał. */
  reviewed: z.boolean(),
});

export const ownerlessPageSchema = z.object({
  items: z.array(ownerlessElementSchema),
  total: z.number(),
  offset: z.number(),
  limit: z.number(),
});

export type OwnerlessBranch = z.infer<typeof ownerlessBranchSchema>;
export type OwnerlessSummary = z.infer<typeof ownerlessSummarySchema>;
export type OwnerlessElement = z.infer<typeof ownerlessElementSchema>;
export type OwnerlessPage = z.infer<typeof ownerlessPageSchema>;

export const ownersContract = {
  OwnerlessBranch: true satisfies MatchesSchema<OwnerlessBranch, 'OwnerlessBranch'>,
  OwnerlessSummary: true satisfies MatchesSchema<OwnerlessSummary, 'OwnerlessSummary'>,
  OwnerlessElement: true satisfies MatchesSchema<OwnerlessElement, 'OwnerlessElement'>,
  OwnerlessPage: true satisfies MatchesSchema<OwnerlessPage, 'OwnerlessPage'>,
} as const;
